Verifies a candidate's identity via SEEK Pass.
